import { Trans } from 'react-i18next';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { ScoreSubmissionSubmittedNotificationData } from './interfaces';

const isScoreSubmissionSubmittedPayload = (
  payload: unknown
): payload is ScoreSubmissionSubmittedNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return 'memberName' in payload && typeof payload.memberName === 'string';
};

export const scoreSubmissionSubmittedPresenter: NotificationPresenter<ScoreSubmissionSubmittedNotificationData> =
  {
    type: 'score-submission-submitted',
    icon: ScoreboardIcon,
    isPayload: isScoreSubmissionSubmittedPayload,
    label: (payload, t) =>
      t('notifications:types.score-submission-submitted', {
        memberName: payload.memberName,
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.score-submission-submitted"
        values={{
          memberName: payload.memberName,
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      const { competitionSlug, submissionId } = payload;

      if (!competitionSlug || !submissionId) {
        return null;
      }

      return ROUTES.manage.competitions.submissionDetails(
        competitionSlug,
        submissionId
      );
    },
  };
